export default "__VITE_ASSET__DPfroqf$__"